import { render, staticRenderFns } from "./PaperWithSvg.vue?vue&type=template&id=fc430318&scoped=true&"
import script from "./PaperWithSvg.vue?vue&type=script&lang=js&"
export * from "./PaperWithSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc430318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc430318')) {
      api.createRecord('fc430318', component.options)
    } else {
      api.reload('fc430318', component.options)
    }
    module.hot.accept("./PaperWithSvg.vue?vue&type=template&id=fc430318&scoped=true&", function () {
      api.rerender('fc430318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/export/PaperWithSvg.vue"
export default component.exports